module.exports = __webpack_public_path__ + "img/wallet-coins.1c5e30d.png";